import { useCookies } from 'react-cookie';
import { SearchItemViewModel } from '@/types/api';
import { getSearchResultItemURL } from '@/features/navigation/utils/url-helpers';
import { IconClock, IconTrash } from '@/features/icons';
import { SEARCH_HISTORY_LOCAL_KEY } from './constants';
import MobileSearchLink from './mobile-search-link';
interface Props {
  title: string;
  items: SearchItemViewModel[] | null;
}
function LastSearchHistory({
  items,
  title
}: Props) {
  const [,, removeCookie] = useCookies([SEARCH_HISTORY_LOCAL_KEY]);
  return <div className='mb-5 lg:px-1' data-sentry-component="LastSearchHistory" data-sentry-source-file="last-search-history.tsx">
            <div className='mb-3 flex items-center justify-between leading-6'>
                <div className='flex flex-row items-center'>
                    <IconClock className='h-5 w-5' data-sentry-element="IconClock" data-sentry-source-file="last-search-history.tsx" />
                    <span className='pr-2 text-sm font-medium'>{title}</span>
                </div>
                <IconTrash className='h-5 w-5 cursor-pointer text-text-mediumGray' onClick={() => removeCookie(SEARCH_HISTORY_LOCAL_KEY)} data-sentry-element="IconTrash" data-sentry-source-file="last-search-history.tsx" />
            </div>
            <ul className='text-text-black'>
                {items?.map(item => <li key={item.id} className='mb-2 text-sm'>
                        <MobileSearchLink href={getSearchResultItemURL(item)} item={item}>
                            <span className='text-text-darkGray'>{item.nameFa}</span>
                        </MobileSearchLink>
                    </li>)}
            </ul>
        </div>;
}
export default LastSearchHistory;